export default __webpack_public_path__ + "static/media/SYSTEM_OWNER.22245c3d.svg";